import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import WhatsAppButton from "../../components/feature/WhatsAppButton";

const testimonials = [
  {
    name: "Dr. Andrea Walsh",
    role: "Medical Clinic Director",
    location: "Seattle, WA",
    rating: 5,
    text: "Prime Shine WA maintains our medical clinic to the highest sanitation standards. Their team understands healthcare cleaning protocols, uses hospital-grade disinfectants, and is always punctual. Absolutely essential for our practice.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20doctor%20clinic%20director%20headshot%20portrait%2C%2042%20years%20old%2C%20warm%20confident%20smile%2C%20white%20coat%2C%20clean%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=rev001&orientation=squarish",
  },
  {
    name: "Marcus Reynolds",
    role: "Office Manager — Reynolds Corp",
    location: "Bellevue, WA",
    rating: 5,
    text: "We manage a 5,000 sq ft office space and Prime Shine has been cleaning it weekly for two years. Spotless results every single time. Our employees love the clean environment and we've had zero complaints from clients about our office appearance.",
    avatar: "https://readdy.ai/api/search-image?query=confident%20professional%20black%20businessman%20office%20manager%20headshot%20portrait%2C%2038%20years%20old%2C%20friendly%20smile%2C%20business%20attire%2C%20clean%20background%2C%20corporate%20photography%20style&width=80&height=80&seq=rev002&orientation=squarish",
  },
  {
    name: "Carlos Vega",
    role: "General Manager — Pacific Auto Group",
    location: "Redmond, WA",
    rating: 5,
    text: "Our car dealership showroom is immaculate thanks to Prime Shine. They clean the showroom floors, offices, service waiting area, and bathrooms. Every morning our facility looks brand new. Customer comments on the cleanliness all the time!",
    avatar: "https://readdy.ai/api/search-image?query=professional%20hispanic%20man%20car%20dealership%20manager%20headshot%20portrait%2C%2045%20years%20old%2C%20confident%20warm%20smile%2C%20business%20casual%2C%20clean%20background%2C%20high%20quality%20portrait&width=80&height=80&seq=rev003&orientation=squarish",
  },
  {
    name: "Linda Park",
    role: "Property Manager — NW Properties",
    location: "Kirkland, WA",
    rating: 5,
    text: "I manage over 20 commercial properties and Prime Shine is my go-to for all move-out cleanings. They're thorough, professional, and fast. Every unit comes back spotless — tenants love moving into a Prime Shine-cleaned space.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20woman%20property%20manager%20headshot%20portrait%2C%2040%20years%20old%2C%20warm%20confident%20smile%2C%20business%20attire%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=rev004&orientation=squarish",
  },
  {
    name: "James O'Brien",
    role: "Facilities Director — Northwest Tech Hub",
    location: "Seattle, WA",
    rating: 5,
    text: "We run a 10,000 sq ft tech campus and Prime Shine handles daily cleaning of our open workspaces, conference rooms, labs, and cafeteria. Their team is discreet, professional, and the quality is consistently outstanding.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20irish%20american%20man%20facilities%20director%20headshot%20portrait%2C%2050%20years%20old%2C%20authoritative%20friendly%20smile%2C%20business%20casual%2C%20clean%20office%20background%2C%20corporate%20photography&width=80&height=80&seq=rev005&orientation=squarish",
  },
  {
    name: "Sofia Martinez",
    role: "Dental Practice Owner",
    location: "Bothell, WA",
    rating: 5,
    text: "Running a dental office requires impeccable cleanliness standards. Prime Shine WA exceeds our expectations every visit. They handle sterilization of waiting areas, operatory prep areas, and bathrooms with care and precision.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20latina%20female%20dentist%20practice%20owner%20headshot%20portrait%2C%2035%20years%20old%2C%20warm%20bright%20smile%2C%20scrubs%2C%20clean%20clinic%20background%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=rev006&orientation=squarish",
  },
];

const ReviewsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [active, setActive] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 5500);
    return () => clearInterval(interval);
  }, []);

  const current = testimonials[active];

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }}>
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-32 pb-20 bg-[#0F2A44] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20gold%20and%20navy%20geometric%20pattern%2C%20minimalist%20premium%20luxury%20texture%20background%2C%20high%20resolution%2C%20elegant%20professional%20visual%20for%20testimonials%20page&width=1920&height=600&seq=revbg001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <span className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-4 block">
            {t("testimonials_label")}
          </span>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-5">
            {t("testimonials_headline")}
          </h1>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            {t("testimonials_sub")}
          </p>
          <div className="flex justify-center mt-8 text-sm text-white/50">
            <Link to="/" className="hover:text-[#D4AF37] transition-colors duration-200">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-[#D4AF37]">Reviews</span>
          </div>
        </div>
      </section>

      {/* Rating Summary */}
      <section className="bg-white py-12 border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { val: "4.9", label: "Average Rating", icon: "ri-star-fill" },
              { val: "247+", label: "Google Reviews", icon: "ri-google-fill" },
              { val: "100%", label: "Recommend Us", icon: "ri-thumb-up-fill" },
              { val: "500+", label: "Happy Clients", icon: "ri-user-smile-line" },
            ].map((item) => (
              <div key={item.label} className="p-5 rounded-2xl bg-[#F5F5F5]">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#D4AF37]/20 mx-auto mb-3">
                  <i className={`${item.icon} text-lg text-[#D4AF37]`} />
                </div>
                <p className="text-3xl font-bold text-[#0F2A44]">{item.val}</p>
                <p className="text-gray-400 text-xs mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Testimonial Carousel */}
      <section className="py-20 bg-[#F5F5F5]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-3 block">FEATURED REVIEW</span>
            <h2 className="text-3xl font-bold text-[#0F2A44]">What Our Clients Say</h2>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 mb-8" style={{ boxShadow: "0 4px 40px rgba(0,0,0,0.08)" }}>
            <div className="flex flex-col md:flex-row items-start gap-8">
              <div className="shrink-0">
                <span className="text-8xl text-[#D4AF37]/30 font-serif leading-none">&ldquo;</span>
              </div>
              <div>
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: current.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#D4AF37] text-lg" />
                  ))}
                </div>
                <p className="text-[#1A1A1A] text-lg md:text-xl leading-relaxed mb-6 font-light">
                  &ldquo;{current.text}&rdquo;
                </p>
                <div className="flex items-center gap-4">
                  <img
                    src={current.avatar}
                    alt={current.name}
                    className="w-12 h-12 rounded-full object-cover object-top"
                    loading="lazy"
                  />
                  <div>
                    <p className="font-bold text-[#0F2A44] text-base">{current.name}</p>
                    <p className="text-gray-400 text-sm">{current.role} &bull; {current.location}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mb-12">
            <button
              onClick={() => setActive((active - 1 + testimonials.length) % testimonials.length)}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-sm" />
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  className={`rounded-full transition-all duration-300 cursor-pointer ${i === active ? "w-6 h-2.5 bg-[#D4AF37]" : "w-2.5 h-2.5 bg-[#D4AF37]/30"}`}
                />
              ))}
            </div>
            <button
              onClick={() => setActive((active + 1) % testimonials.length)}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-sm" />
            </button>
          </div>
        </div>
      </section>

      {/* All Reviews Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#0F2A44]">All Client Reviews</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((review, i) => (
              <div
                key={i}
                className={`p-6 rounded-2xl border-2 transition-all duration-200 cursor-pointer ${
                  i === active ? "border-[#D4AF37] bg-[#D4AF37]/5" : "border-gray-100 hover:border-[#D4AF37]/40"
                }`}
                onClick={() => setActive(i)}
                style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.05)" }}
              >
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover object-top"
                    loading="lazy"
                  />
                  <div>
                    <p className="font-bold text-[#0F2A44] text-sm">{review.name}</p>
                    <p className="text-gray-400 text-xs">{review.role}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-[#D4AF37] text-xs" />
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">{review.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0F2A44] py-16 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Ready to Join Our Happy Clients?</h2>
          <p className="text-white/65 mb-8">Get your free quote today and experience the Prime Shine difference.</p>
          <button
            onClick={() => navigate("/contact")}
            className="inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#B8952E] text-[#0F2A44] font-bold px-10 py-4 rounded-full text-base transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Get Free Quote
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default ReviewsPage;
